module.exports = __webpack_public_path__ + "static/img/property_1_usdt.5328dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_usdt.png
// module id = hbts
// module chunks = 1